import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@components/ui/sidebar';
import { useSidebar } from '@components/ui/sidebar/useSidebar';
import { useHeader } from '@contexts/header';
import { useLocation, useNavigate } from 'react-router';

function MenuSidebar() {
  const { topics } = useHeader();
  const navigate = useNavigate();
  const location = useLocation();
  const { leftSidebar } = useSidebar();

  return (
    <Sidebar className="border-input z-0 border-r pt-[125px]" side="left">
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarMenu className="gap-0">
              {topics.map((item) => (
                <SidebarMenuItem key={item.name}>
                  <SidebarMenuButton
                    asChild
                    className="h-fit cursor-pointer hover:bg-transparent active:bg-transparent [&>span:last-child]:text-wrap">
                    <button onClick={() => leftSidebar.setOpenMobile(false)}>
                      <a
                        href={`#${item.id}_${item.name}`}
                        onClick={() => {
                          navigate(
                            `${location.pathname}${location.search}#${item.id}_${item.name}`,
                            {
                              replace: true,
                            },
                          );
                        }}>
                        <span className="text-background hover:text-secondary text-sm font-medium">
                          {item.name}
                        </span>
                      </a>
                    </button>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
      <SidebarFooter />
    </Sidebar>
  );
}

export default MenuSidebar;
